// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".password-suggestions span{float:left;clear:left}#resendCodeButtonGrid{position:relative}#resendCodeButton{position:absolute;bottom:5px;margin-left:5px}\n", ""]);
// Exports
module.exports = exports;
